(ns storrito.editor.image
  (:require [storrito.fabricjs.state :as f]
            [storrito.editor.fit-object :as fit-object]
            [storrito.editor.centering :as centering]
            ["fabric" :refer [fabric]]
            [cljs.core.async :as async]
            [storrito.app.message :as message]))

(defn add-image-from-url!
  [image-url & [opts]]
  (let [chan (async/promise-chan)]
    (js/fabric.Image.fromURL image-url
                             (fn [image]
                               (try
                                 (if-let [canvas (f/get-canvas)]
                                   (do
                                     (.set image
                                         "canvas"
                                         canvas)
                                     (f/insert! canvas
                                                (f/assign! image
                                                           (fit-object/fit-object image))))
                                   (throw (ex-info "Canvas was nil" {})))
                                 (catch js/Error e
                                   (js/console.error e)
                                   (message/show-message! {:type     :danger
                                                           :duration 8000
                                                           :content  "Could not add image. Please try again or contact the support."})))
                               (centering/center! image)
                               (async/put! chan
                                           image))
                             #js{:id (:id opts
                                       (str "image-" (random-uuid)))
                                 :crossOrigin "anonymous"})
    chan))
